
import { defineComponent, h, VNodeArrayChildren } from "vue";
import CarouselControlls from "./CarouselControlls.vue";
import CarouselCell from "./CarouselCell.vue";
import programs, { ProgramList } from "@/program";
import { mapMutations, mapState } from "vuex";

export default defineComponent({
  components: {
    CarouselControlls,
    CarouselCell,
  },

  data: (): {
    programs: ProgramList;
    raf: null | number;
    width: number;
    height: number;
    perspective: number;
    transition: boolean;
    mounted: boolean;
    startX: number;
  } => {
    return {
      programs,
      raf: null,
      width: 200,
      height: 140,
      perspective: 1500,
      transition: true,
      mounted: true,
      startX: 0,
    };
  },
  props: {
    ground: String,
    top: String,
  },
  mounted() {
    this.scale();
    window.addEventListener("resize", this.scale);
    window.addEventListener("touchstart", this.touchstart);
    window.addEventListener("touchend", this.touchend);
  },
  beforeUnmount() {
    this.mounted = false;
    window.removeEventListener("touchstart", this.touchstart);
    window.removeEventListener("touchend", this.touchend);
  },
  computed: {
    ...mapState({
      index: "index",
      first: "first",
    }),
  },
  methods: {
    touchstart(e: TouchEvent) {
      this.startX = e.touches[0].screenX;
    },
    touchmove(e: TouchEvent) {},
    touchend(e: TouchEvent) {
      const delta = e.changedTouches[0].screenX - this.startX;
      if (Math.abs(delta) > 50) {
        if (delta < 0) {
          this.prev();
        } else {
          this.next();
        }
      }
      this.startX = 0;
    },
    ...mapMutations({
      next: "next",
      prev: "prev",
      goTo: "goto",
      doScrollLeft: "scrollLeft",
      doScrollRight: "scrollRight",
      setFirst: "first",
    }),
    scale() {
      this.height = window.innerHeight * 0.64;
      this.width = this.height * 0.7;
      if (this.width > window.innerWidth * 0.7) {
        this.width = window.innerWidth * 0.7;
        this.height = this.width / 0.7;
      }
    },
    cancelScroll() {
      this.transition = true;
      if (this.raf) {
        cancelAnimationFrame(this.raf);
      }
      this.goTo(Math.round(this.index));
    },
    scrollLeft() {
      this.doScrollLeft();
      this.raf = this.mounted
        ? requestAnimationFrame(() => this.scrollLeft())
        : null;
      this.transition = false;
    },
    scrollRight() {
      this.doScrollRight();
      this.raf = requestAnimationFrame(this.scrollRight);
      this.transition = false;
    },
  },
  render() {
    const rotation = 360 / programs.length;
    const offset =
      Math.floor(this.width / 2 / Math.tan(Math.PI / programs.length)) * 1.11;
    return [
      h(
        "div",
        {
          class: "carousel_scene",
          style: {
            width: `${this.width}px`,
            height: `${this.height}px`,
            position: `relative`,
            perspective: `135vh`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        },
        h(
          "div",
          {
            class: this.first ? "carousel_intro first" : "carousel_intro",
            style: {
              width: "100%",
              height: "100%",
              transformStyle: "preserve-3d",
            },
          },
          h(
            "div",
            {
              class: "carousel_carousel",
              style: {
                width: `${this.width}px`,
                height: `${this.height}px`,
                position: "absolute",
                willChange: "transform",
                transformStyle: "preserve-3d",
                transform: `translateZ(${offset}px) rotateY(${this.index *
                  -rotation}deg)`,
                transition: this.transition ? "transform 0.5s linear" : "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                pointerEvents: "none",
              },
            },
            [
              ...programs.map((program, i) => {
                const deg = rotation * i;
                const width = this.width;
                const height = this.height;
                const to = `/${program.slug}`;
                const src = `/img/film/${program.slug}/poster.png`;
                return h(CarouselCell, {
                  deg,
                  offset,
                  width,
                  height,
                  to,
                  src,
                  click: () => {
                    let normIndex = Math.round(
                      this.index % this.programs.length
                    );
                    normIndex =
                      normIndex >= 0
                        ? normIndex
                        : this.programs.length + normIndex;
                    let diff = i - normIndex;
                    if (Math.abs(diff) > this.programs.length / 2) {
                      diff =
                        diff > 0
                          ? -(this.programs.length - diff)
                          : this.programs.length + diff;
                    }
                    this.goTo(Math.round(this.index) + diff);
                    this.setFirst(false);
                    this.$router.push({ path: to });
                  },
                });
              }),
            ]
          )
        )
      ),
      h(CarouselControlls, {
        next: () => this.prev(),
        prev: () => this.next(),
        onLeftEnter: this.scrollLeft,
        onLeftLeave: this.cancelScroll,
        onRightEnter: this.scrollRight,
        onRightLeave: this.cancelScroll,
      }),
    ];
  },
});
